import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {EntityCategoryTreePrev} from '@common/components-standalone/reference-category-module/category.type';

export const LoadCategories = createAction(
    '[Documents] Load Categories',
    props<{ uuid: string }>()
);

export const LoadCategoriesSuccess = createAction(
    '[Documents] Load Categories Success',
    props<{ categories: EntityCategoryTreePrev[] }>()
);

export const LoadCategoriesFailure = createAction(
    '[Documents] Load Categories Failure',
    props<{ error: HttpErrorResponse }>()
);
